import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import Slider from './../slider';



const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        minHeight: "65vh",
        // backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/assets/images/header1.jpeg');`,
        backgroundColor:'#071b2c',
        width: "100%",
        // minHeight: 500,
        position: "relative",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50%",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    grid: {
        color: 'white',
        width:'100%',
        [theme.breakpoints.down('1000')]: {
            height:'100%',
        },
        '& > div > h1': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '3em',
            fontWeight: 900,
            [theme.breakpoints.down("sm")]: {
                fontSize: '1.1em',
            },
            [theme.breakpoints.down("xs")]: {
                fontSize: '0.9em',
            }
        }
    },
    head: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    btn: {
        textAlign: 'center',
        margin: 'auto !important',
        display: 'flex',
        justifyContent: 'center',
        flexWrap :'wrap'
    },
    color: {
        color: theme.palette.light.type2
    },
    
}))


export default function HeaderHome({home}) {

    const classes = useStyles();

    return (
        <div>
            <Box className={classes.root}>
                <Box className={classes.grid}>
                   <Slider />
                </Box>
            </Box>
        </div>
    )
}
